import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';

let uid = 0;

export namespace NCmsFaqComponent {
    export const ID = 'faq';

    export interface IData extends NICmsContentComponent.IData, NTextBox.IData {
        isHorizontal: boolean;
        items: IItem[];
    }

    interface IItem {
        question: string;
        answer: string;
        answerAlignment?: string;
    }
}

@ICmsComponent<CmsFaqComponent>({
    id: NCmsFaqComponent.ID,
    name: 'FAQ',
    tags: ['Accordion', 'F&Q'],
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'isHorizontal',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Layout',
            labels: { true: 'Horizontal', false: 'Vertical' },
            description: 'This setting affects the layout only in the desktop view',
            default: false
        },
        {
            key: 'headerLabel',
            type: NICmsContentField.EFieldType.label,
            title: 'Header'
        },
        ...NTextBox.getFields(false, false),
        {
            key: 'accordionLabel',
            type: NICmsContentField.EFieldType.label,
            title: 'Accordion'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'items',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Questions',
            itemName: 'Question',
            itemNameField: 'question',
            required: true,
            fields: [
                {
                    key: 'question',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Question',
                    default: 'Question goes here',
                    required: true
                },
                {
                    key: 'answer',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Answer',
                    default: 'Answer goes here',
                    required: true
                },
                {
                    key: 'answerAlignment',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Answer alignment',
                    options: [
                        { key: 'left', title: 'Left' },
                        { key: 'center', title: 'Center' },
                        { key: 'right', title: 'Right' }
                    ],
                    default: 'left'
                }
            ]
        }
    ]
})
@Component({
    standalone: true,
    imports: [TextBoxComponent, ImageModule, ICmsClientModule, HideUpComponent, ToggleModule, NgClass],
    selector: 'cms-faq',
    templateUrl: './cms-faq.html',
    styleUrl: 'cms-faq.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsFaqComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsFaqComponent.IData;

    protected readonly toggleService = inject(ToggleService);
    protected readonly uid = `cms-faq-${uid++}`;

    protected get isHorizontal(): boolean {
        return this.component.isHorizontal && !this.client.isS && !this.client.isM;
    }
}
